import type { QueryClient } from '@tanstack/react-query'
import type { Request, RequestItem } from '../../../shared/api/types'

/**
 * Оптимистично патчит одну позицию в кэше заявки без полного refetch.
 *
 * Полный invalidate перетаскивает все 500+ позиций по сети и заставляет
 * AG Grid пересобрать rowData — это и есть то «зависание» на ~300мс,
 * которое было в StatusCell/PriorityCell/MatrixSelect/AssignSelect после
 * каждой смены значения.
 */
export function patchItemInCache(
  queryClient: QueryClient,
  requestId: string,
  itemId: string,
  patch: Partial<RequestItem>,
): void {
  queryClient.setQueryData<Request>(['requests', requestId], (old) => {
    if (!old?.items) return old
    return {
      ...old,
      items: old.items.map((it) => (it.id === itemId ? { ...it, ...patch } : it)),
    }
  })
}
